/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from 'theme-ui';
import sizes from './sizes';

export default function CloseIcon({ size = 'small', ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      sx={{
        width: sizes[size],
        height: sizes[size],
        verticalAlign: 'middle',
      }}
      width={sizes[size]}
      height={sizes[size]}
      viewBox="0 0 20 20"
      {...rest}
    >
      <path
        fill="currentColor"
        d="M10.70725,10.00025 L19.35325,1.35425 C19.54925,1.15825 19.54925,0.84225 19.35325,0.64625 C19.15825,0.45125 18.84225,0.45125 18.64625,0.64625 L10.00025,9.29325 L1.35325,0.64625 C1.15825,0.45125 0.84225,0.45125 0.64625,0.64625 C0.45125,0.84225 0.45125,1.15825 0.64625,1.35425 L9.29325,10.00025 L0.64625,18.64625 C0.45125,18.84225 0.45125,19.15825 0.64625,19.35425 C0.74425,19.45125 0.87225,19.50025 1.00025,19.50025 C1.12825,19.50025 1.25625,19.45125 1.35325,19.35425 L10.00025,10.70725 L18.64625,19.35425 C18.74425,19.45125 18.87225,19.50025 19.00025,19.50025 C19.12825,19.50025 19.25625,19.45125 19.35325,19.35425 C19.54925,19.15825 19.54925,18.84225 19.35325,18.64625 L10.70725,10.00025 Z"
      ></path>
    </svg>
  );
}
